'use strict';

module.exports = {
  addClientToRequest: 'add-client-to-request',
  assignGuestToRequest: 'assign-guest-to-request',
  baseUserRegistration: 'base-user-registration',
  confirmAvailabilityWithProposal: 'confirm-availability-with-proposal',
  clientBookedElsewhere: 'client-booked-elsewhere',
  clientCancelPostDeposit: 'client-cancel-post-deposit',
  depositPaid: 'deposit-paid',
  processedRefund: 'processed-refund',
  depositPaymentTransactionError: 'deposit-payment-transaction-error',
  refundTransactionError: 'refund-transaction-error',
  finalizeMenu: 'finalize-menu',
  finalPaymentPaid: 'final-payment-paid',
  guestAcceptAlteration: 'guest-accepted-alteration',
  guestCancelRequest: 'booking-request-cancelled-by-guest',
  guestConfirmBooking: 'booking-request-confirmed-by-guest',
  hostAcceptRequest: 'booking-request-accepted',
  hostCounteroffer: 'host-counteroffer',
  hostDeclineRequest: 'booking-request-declined-by-host',
  hostCancelProposal: 'proposal-cancelled-by-host',
  hostSubmitAlteration: 'host-submitted-alteration',
  hostSubmitProposal: 'host-submit-proposal',
  inviteUserToLead: 'invite-user-to-lead',
  inviteUserToList: 'invite-user-to-list',
  manualFinalPaymentOutstanding: 'manual-final-payment-outstanding',
  manualFinalBalancePaid: 'manual-final-balance-paid',
  notifyVenueOfSentProposal: 'notify-venue-of-sent-proposal',
  onboardingVenueSuccess: 'onboarding-venue-success',
  oneDayBalancePaymentReminder: 'one-day-balance-payment-reminder',
  paymentPaid: 'payment-paid',
  privateEventFormSubmitted: 'submitted-concierge-form',
  proposalMessage: 'proposal-message',
  publishVenue: 'publish-venue',
  reconcileEvent: 'reconcile-event',
  reconcileEventNoPayment: 'reconcile-event-no-payment',
  registration: 'registration',
  remindFinalizeChanges: 'remind-finalize-changes',
  remindSendReceipt: 'remind-send-receipt',
  remindSubmitManualBalancePayment: 'remind-submit-manual-balance-payment',
  requestReview: 'request-review',
  resetPassword: 'reset-password',
  reviewEvent: 'review-event',
  reviewVenue: 'review-venue',
  scheduledPaymentTransactionError: 'scheduled-payment-transaction-error',
  sendConciergeMessage: 'send-concierge-message',
  sendNewLeadInformation: 'send-new-lead-information',
  sendProposalLink: 'send-proposal-link',
  submitRequest: 'booking-request-submitted-for-review',
  submitRecos: 'submitted-recos',
  sendLeadConfirmationMessage: 'send-lead-confirmation-message',
  threeDayBalancePaymentReminder: 'three-day-balance-payment-reminder',
  venueCancelPostDeposit: 'venue-cancel-post-deposit',
  venueUserAdded: 'venue-user-added',
  venueUserCreated: 'venue-user-created',
  cancelledPostDepositByClient: 'cancelled-post-deposit-by-client',
  cancelRequestPostDepositByClient: 'cancel-request-post-deposit-by-client',
  cancelledPostDepositByVenue: 'cancelled-post-deposit-by-venue',
  reviewForVenue: 'review-for-venue',
  intermediateEventFailed: 'Intermediate-payment-failed',
  inviteBaseUserToAccount: 'invite-base-user-account',
  venueFirstBooking: 'venue-first-booking',
  magicLinkLogin: 'magic-link-login',
  magicLinkRegister: 'magic-link-register',
  magicLinkBaseUserRegistration: 'magic-link-base-user-registration'
};